

import axios, { AxiosRequestConfig } from 'axios';

export interface AxiosResponseType<T = never> {
  code: number;
  data: T;
  msg: string;
  header?: { [key: string]: string; };
}

export async function post<T>(url: string, data = {}, config?: AxiosRequestConfig): Promise<AxiosResponseType<T>> {
  const { ...restConfig } = config || {};

  return new Promise<AxiosResponseType<T>>((resolve, reject) => {
    axios.post<any, AxiosResponseType<T>, any>(url, data, restConfig).then((res) => {
      const body = res as unknown as AxiosResponseType<T>;
      if (body.code !== 200) {
        reject({
          ...body,
          msg: body.msg,
          message: body.msg,
        });
        return;
      }
      resolve(body);
    }).catch(e => {
      console.error('[Request Error]', e);

      reject(e);
    });
  });
}
